export default "__VITE_ASSET__DMyoVxfq__"